import axios from "axios";
import { Message } from "@/api/types";

export const getGlobal = () => axios.get<Message>('/messages/global');
export const getPublicGlobal = () => axios.get<Message>('/messages/public');
export const createGlobal = (body: string, scope: 'dashboard' | 'global' = 'dashboard') =>
  axios.post<Message>('/messages/global', { body, scope });
export const createMessage = (user_id: number, body: string) => axios.post<Message>(`/messages/${ user_id }`, { body });
export const deleteMessage = (id: number) => axios.delete(`/messages/${ id }`);
